import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { PaymentOption } from '../../types';
import { getPaymentSchemeOptionColumns } from '../../utils/PaymentSchemeTable';
import { dataGridSx } from '../../../common/styled/DataGrid';
import pallet from '../../../../layouts/pallet';
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog';
import { useFeeStructureContext } from '../../context/FeeStructureContext';
import tableColumnUtils from '../../../../utils/tableColumnUtils';
import CustomDataGridToolbar from '../../../common/components/CustomDataGridToolbar';

const PaymentSchemeTable = () => {
  const { paymentOptionData, handlePaymentSchemeDelete, handleTableRowEdit } =
    useFeeStructureContext();
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<PaymentOption | null>(
    null
  );

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const handleRowDelete = (row: any) => {
    setSelectedRowData(row);
    setConfirmationDialogOpen(true);
  };

  const handleOnConfirmDelete = () => {
    setIsDeleting(true);
    handlePaymentSchemeDelete({ selectedRowData });
    setConfirmationDialogOpen(false);
    setIsDeleting(false);
  };

  const handleConfirmDialogClose = () => {
    setSelectedRowData(null);
    setConfirmationDialogOpen(false);
  };

  const columns = getPaymentSchemeOptionColumns(
    handleTableRowEdit,
    handleRowDelete
  );

  return (
    <>
      <DataGrid
        rowHeight={50}
        rows={paymentOptionData}
        columns={columns}
        getRowId={(row) => row._id}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
      <ConfirmationDialog
        message={`Are you sure you want to delete ${selectedRowData?.schemeName} for Grade 2?`}
        onClose={handleConfirmDialogClose}
        open={confirmationDialogOpen}
        onConfirm={handleOnConfirmDelete}
        disable={isDeleting}
      />
    </>
  );
};

export default PaymentSchemeTable;
